import React from 'react';
interface HeaderProps {
  step: number;
  totalSteps: number;
}
export function Header({
  step,
  totalSteps
}: HeaderProps) {
  // Calculate progress percentage (only for question steps 1-5)
  const progress = step > 0 && step <= totalSteps ? step / totalSteps * 100 : 0;
  return <header className="bg-amber-900 text-white w-full sticky top-0 z-10 shadow-md" data-id="element-33">
      <div className="flex flex-col items-center justify-center py-1.5 px-6" data-id="element-34">
        <h1 className="text-[9px] font-bold tracking-[0.2em] uppercase opacity-90 mb-1 text-center leading-none" data-id="element-35">
          El Método Maestro
        </h1>

        {step > 0 && step <= totalSteps && <div className="w-full max-w-md" data-id="element-36">
            <div className="h-1 w-full bg-amber-950/50 rounded-full overflow-hidden" data-id="element-37">
              <div className="h-full bg-amber-500 transition-all duration-500 ease-out rounded-full" style={{
            width: `${progress}%`
          }} data-id="element-38" />
            </div>
            <div className="text-center text-[8px] font-medium text-amber-200/80 mt-1 uppercase tracking-wider leading-none" data-id="element-39">
              Pregunta {step} de {totalSteps}
            </div>
          </div>}
      </div>
    </header>;
}